export const isStepSkipped = (step, skipped) => {
    return skipped.has(step);
};

export const handleNext = (
    activeStep,
    skipped,
    setActiveStep,
    setSkipped,
    finishStep,
    updateDeckState,
    deckState,
    setDeckPageOpen
) => {
    let newSkipped = skipped;
    if (finishStep) {
        updateDeckState({ ...deckState, finished: true });
        setDeckPageOpen(false, true);
    }
    if (isStepSkipped(activeStep, skipped)) {
        newSkipped = new Set(newSkipped.values());
        newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
};

export const handleBack = (activeStep, setActiveStep) => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
};

export const handleSkip = (activeStep, skipped, setActiveStep, setSkipped) => {
    // if (!isStepOptional(activeStep)) {
    //   // You probably want to guard against something like this,
    //   // it should never occur unless someone's actively trying to break something.
    //   throw new Error("You can't skip a step that isn't optional.");
    // }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
        const newSkipped = new Set(prevSkipped.values());
        newSkipped.add(activeStep);
        return newSkipped;
    });
};

export const handleReset = (setActiveStep) => {
    setActiveStep(0);
};

export const handleFinish = (deckState) => {};
